<div class="layout-container">
  <!-- Expandible Sidebar Menu -->
  <div
    class="expandible-sidebar"
    [class.expanded]="isSidebarOpen()"
    [class.collapsed]="!isSidebarOpen()"
  >
    <!-- Sidebar Header -->
    <div class="sidebar-header">
      <div class="header-content">
        @if (isSidebarOpen()) {
        <h3>Notifier Viewer</h3>
        }
        <p-button
          [icon]="isSidebarOpen() ? 'pi pi-angle-left' : 'pi pi-angle-right'"
          [rounded]="true"
          [severity]="'success'"
          (onClick)="toggleSidebar()"
          [pTooltip]="isSidebarOpen() ? 'Collapse Sidebar' : 'Expand Sidebar'"
          tooltipPosition="right"
        >
        </p-button>
      </div>
    </div>

    <!-- Sidebar Content -->
    <div class="sidebar-content" [class.hidden]="!isSidebarOpen()">
      <p-divider></p-divider>

      <!-- Filters Card -->
      <p-card header="Filters" class="sidebar-card">
        <app-select-bar style="margin-top: 2rem;"></app-select-bar>
      </p-card>

      <p-divider></p-divider>

      <!-- Actions Card -->
      <p-card header="Actions" class="sidebar-card">
        <div class="action-buttons">
          <p-button
            label="Export All to CSV"
            icon="pi pi-download"
            styleClass="p-button-outlined p-button-primary"
            (onClick)="exportAllToCSV()"
            pTooltip="Export all data to CSV file"
            tooltipPosition="top"
            fluid
          ></p-button>

          @if(enableCSVButton()) {
            <p-button
              label="Export Selected"
              icon="pi pi-file-export"
              styleClass="p-button-outlined p-button-success"
              (onClick)="exportToCSV()"
              pTooltip="Export selected rows to CSV"
              tooltipPosition="top"
              fluid
            ></p-button>

            <p-button
              label="Deselect All"
              icon="pi pi-times"
              styleClass="p-button-outlined p-button-warning"
              (onClick)="deselectAll()"
              pTooltip="Clear all selections"
              tooltipPosition="top"
              fluid
            ></p-button>
          }
        </div>
      </p-card>

      <p-divider></p-divider>

      <!-- Theme Card -->
      <!-- <p-card header="Theme" class="sidebar-card">
        <div>
          <p-toggleButton
            [formControl]="toggleControl"
            [onLabel]="'Dark Mode'"
            [offLabel]="'Light Mode'"
            [onIcon]="'pi pi-moon'"
            [offIcon]="'pi pi-sun'"
          ></p-toggleButton>
        </div>
      </p-card> -->
    </div>

    <!-- Collapsed State Icons -->
    <div class="collapsed-icons" [class.visible]="!isSidebarOpen()">
      <p-button
        icon="pi pi-filter"
        styleClass="p-button-text p-button-rounded collapsed-icon"
        pTooltip="Filters"
        tooltipPosition="right"
        (onClick)="toggleSidebar()"
      >
      </p-button>

      <p-button
        icon="pi pi-cog"
        styleClass="p-button-text p-button-rounded collapsed-icon"
        pTooltip="Actions"
        tooltipPosition="right"
        (onClick)="toggleSidebar()"
      >
      </p-button>

      <!-- <p-button
        [icon]="pageTheme() === 'dark' ? 'pi pi-moon' : 'pi pi-sun'"
        styleClass="p-button-text p-button-rounded collapsed-icon"
        pTooltip="Toggle Theme"
        tooltipPosition="right"
        (onClick)="toggleControl.setValue(!toggleControl.value)"
      >
      </p-button> -->
    </div>
  </div>

  <!-- Main Content Area -->
  <p-card class="main-content" [class.sidebar-expanded]="isSidebarOpen()">
    <div class="grid-container">
      @if (this.projectsService.isDataLoaded()) {
        <div class="grid-toolbar">
          <div class="last-refresh-info">
            <i class="pi pi-clock"></i>
            <span>Last update: <strong>{{ lastRefresh }}</strong></span>
          </div>

          <p-button
            label="Refresh"
            icon="pi pi-refresh"
            size="small"
            styleClass="p-button-outlined p-button-primary"
            (onClick)="refreshGrid()"
            pTooltip="Reload grid data"
            tooltipPosition="left"
          >
          </p-button>
        </div>
        <ag-grid-angular
          #agGrid
          [class]="gridTheme()"
          [gridOptions]="gridOptions"
          (gridReady)="onGridReady($event)"
          (selectionChanged)="onSelectionChanged($event)"
          style="width: 100%; height: 100%"
        ></ag-grid-angular>
        } @else {
        <div class="loading-container">
          <p-progressSpinner
            styleClass="loading-spinner"
            [strokeWidth]="'3'"
            [animationDuration]="'1s'"
          ></p-progressSpinner>
          <p>Loading data...</p>
        </div>
        }
    </div>
  </p-card>
</div>

<!-- Message Dialog Component -->
<app-message-dialog
  [(visible)]="messageDialogVisible"
  [(messageData)]="currentMessageData"
  (visibleChange)="onMessageDialogHide()"
  (copyToClipboard)="onMessageCopied($event)">
</app-message-dialog>
